export default __webpack_public_path__ + "static/media/Zone-4-Master-Plan-Type-G.aba3d2a4.png";